import styled from 'styled-components';
import { spinAnimation } from 'js/config/style';

export default styled.img.attrs({ src: '/images/spinner.svg' })`
  ${spinAnimation};
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  width: ${({ size }) => size || '4.375rem'};
  max-width: 100%;
  object-fit: cover;
`;
